// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class IdleTimeoutService {

//   constructor() { }
// }
import { Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "app/core/auth/auth.service";

@Injectable({
  providedIn: "root",
})
export class IdleTimeoutService {
  private timeout: any;
  private readonly idleTime = 40 * 60 * 1000; // 40 minutes in milliseconds
  // private readonly idleTime = 5 * 1000; // 1 minutes in milliseconds

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private auth: AuthService
  ) {
    auth.check().subscribe((val: any) => {
      if (val) {
        this.initListener();
        this.resetTimer();
      }
    });
  }

  private initListener(): void {
    const events = ["click", "mousemove", "keydown", "scroll", "touchstart"];

    events.forEach((event) => {
      window.addEventListener(event, () => this.resetTimer());
    });
  }

  private resetTimer(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.ngZone.runOutsideAngular(() => {
      this.timeout = setTimeout(() => {
        this.ngZone.run(() => {
          this.logout();
        });
      }, this.idleTime);
    });
  }

  private logout(): void {
    // localStorage (and the access token in it) is deliberately left
    // intact here: AuthSignOutComponent on /sign-out calls
    // AuthService.signOut(), which now needs that token to revoke the
    // session server-side before clearing local storage itself. Clearing
    // it here first — as this used to — meant an idle-triggered logout
    // never actually reached the backend logout call, silently leaving
    // the session valid server-side (VAPT 3.5 / ET-1608).
    sessionStorage.clear();

    // this.router.navigate(['/login']);
    window.location.href = "/sign-out";
  }
}
